export default {
  // meet_big: {
  //   overlay:
  //     "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-slate-600 bg-opacity-30",
  //   container:
  //     "w-full md:w-[755px] h-[100dvh] md:h-auto md:max-h-[calc(100vh-2rem)] bg-paper overflow-hidden md:rounded-[24px] pt-8 md:pt-12 pb-[calc(2rem+env(safe-area-inset-bottom))]",
  //   header: "relative flex justify-between items-center px-4 md:px-6 mb-4",
  //   closeButton: "absolute right-4 md:right-6 lg:right-6 top-1 z-10",
  //   closeIcon: "h-7 w-7 text-gray_2 hover:text-gray_1",
  //   title:
  //     "flex-1 text-[24px] md:text-[28px] xl:text-[32px] font-bold text-text leading-tight my-0",
  //   headerContent: "flex items-center",
  //   contentWrapper:
  //     "w-full h-full max-h-[calc(100dvh-12rem-env(safe-area-inset-bottom))] overflow-y-auto scrollbar-thin scrollbar-thumb-gray_3 scrollbar-track-paper px-4",
  //   content: "w-full h-full md:px-6 md:pb-4",
  // },
  
  //Used for Success, MagicLink, Provider, etc.
  meet_medium: {
    overlay:
      "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-slate-600 bg-opacity-30",
    container:
      "w-full md:w-[755px] h-full md:h-auto md:max-h-[calc(100vh-2rem)] bg-paper md:rounded-[24px] py-8",
    header: "relative flex justify-between items-center px-10 mb-0",
    closeButton: "absolute right-6 md:right-8 top-0 md:top-1 z-10",
    closeIcon: "h-7 w-7 text-gray_2 hover:text-gray_1",
    title:
      "flex-1 text-[24px] md:text-[28px] xl:text-[32px] font-bold text-text text-center md:text-left leading-tight mt-8 mb-0 md:my-0",
    headerContent: "flex items-center",
    contentWrapper:
      "w-full max-h-[calc(100vh-10rem)] overflow-y-auto scrollbar-thin scrollbar-thumb-gray_3 scrollbar-track-paper px-4",
    content: "w-full md:px-6 md:py-0",
  },

  // meet_wide: {
  //   overlay:
  //     "fixed top-0 left-0 w-full h-full flex items-center justify-center bg-slate-600 bg-opacity-30",
  //   container:
  //     "bg-paper overflow-hidden rounded-[24px] py-0 md:mx-4",
  //   header: "relative flex justify-between items-center",
  //   closeButton: "absolute top-4 right-4 z-10",
  //   closeIcon: "h-7 w-7 text-gray_2 hover:text-gray_1",
  //   title: "flex-1 text-[24px] md:text-[28px] xl:text-[32px] font-bold text-text leading-tight my-0",
  //   headerContent: "flex items-center",
  //   contentWrapper: "w-full h-full px-0",
  //   content: "w-full h-full",
  // },
}
